const READ_URL   = process.env.REACT_APP_N8N_QNA_READ_URL;
const UPDATE_URL = process.env.REACT_APP_N8N_QNA_UPDATE_URL;
const EMAIL_URL  = process.env.REACT_APP_N8N_QNA_EMAIL_URL;
const NOTIFY_URL        = process.env.REACT_APP_N8N_QNA_NOTIFY_URL;
const NOTIFY_ANSWER_URL = process.env.REACT_APP_N8N_QNA_NOTIFY_ANSWER_URL;
const SECRET            = process.env.REACT_APP_N8N_SECRET;

const authHeaders = { 'x-api-key': SECRET || '' };

const checkConfig = (url, name) => {
  if (!url) throw new Error(`${name} غير مضبوط في ملف .env`);
};

const parseJSON = async (res) => {
  const text = await res.text();
  if (!text || !text.trim()) throw new Error(`الخادم أعاد استجابة فارغة (${res.status})`);
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(`استجابة غير صالحة من الخادم: ${text.slice(0, 120)}`);
  }
};

const get = async (url) => {
  checkConfig(url, 'REACT_APP_N8N_QNA_READ_URL');
  const res = await fetch(url, { headers: authHeaders });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await parseJSON(res);
  if (json.error) throw new Error(json.error);
  return json;
};

const post = async (url, params) => {
  checkConfig(url, 'REACT_APP_N8N_QNA_UPDATE_URL');
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...authHeaders,
    },
    body: new URLSearchParams(params).toString(),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await parseJSON(res);
  if (json.error) throw new Error(json.error);
  return json;
};

const qnaService = {
  getAll:        ()                   => get(READ_URL),
  updateSheikh:  (id, sheikh)         => post(UPDATE_URL, { action: 'updateSheikh', id, value: sheikh }),
  updateStatus:  (id, status)         => post(UPDATE_URL, { action: 'updateStatus', id, value: status }),
  updateAnswer:  (id, answer)         => post(UPDATE_URL, { action: 'updateAnswer', id, value: answer }),
  updateNotes:   (id, notes)          => post(UPDATE_URL, { action: 'updateANotes', id, value: notes }),
  updateAudit:   (id, audited)        => post(UPDATE_URL, { action: 'updateAudit',  id, value: audited ? 'true' : 'false' }),
  sendEmail: (q) => {
    if (!EMAIL_URL) throw new Error('REACT_APP_N8N_QNA_EMAIL_URL غير مضبوط في ملف .env');
    return post(EMAIL_URL, {
      action:       'sendAnswerEmail',
      id:           q.id,
      email:        q.email,
      name:         q.name,
      ticketNumber: q.ticketNumber || '',
      question:     q.question,
      answer:       q.answer,
    });
  },
  notifySheikh: ({ sheikhName, sheikhEmail, ticketNumber, questionId }) => {
    if (!NOTIFY_URL) return Promise.resolve();
    return post(NOTIFY_URL, {
      action:       'notifySheikh',
      sheikhName,
      sheikhEmail,
      ticketNumber,
      questionId,
    });
  },
  notifyAdminsAuditors: ({ sheikhName, ticketNumber, questionId }) => {
    if (!NOTIFY_ANSWER_URL) return Promise.resolve();
    return post(NOTIFY_ANSWER_URL, {
      action:       'notifyAdminsAuditors',
      sheikhName,
      ticketNumber,
      questionId,
    });
  },
};

export default qnaService;
